import ms from 'ms';

export const PER_PAGE = 50;
export const CATEGORIES_SEARCH_DEBOUNCE_TIME = 300;
export const CATEGORIES_QUERY_STALE_TIME = ms('5m');
